const HOME_TEAM = "home";
const AWAY_TEAM = "away";
const normalizeOnServeValue = (onServeValue) => {
    if (onServeValue.toLowerCase() === HOME_TEAM) {
        return HOME_TEAM;
    }
    if (onServeValue.toLowerCase() === AWAY_TEAM) {
        return AWAY_TEAM;
    }
    return undefined;
};
export const getOnServe = (metadata) => {
    const { onServe, currentBattingTeam, inPossession, atBat } = metadata !== null && metadata !== void 0 ? metadata : {};
    const serveValue = onServe || currentBattingTeam || inPossession || atBat;
    return serveValue ? normalizeOnServeValue(serveValue) : undefined;
};
const teamMap = { 1: { home: true }, 2: { away: true } };
const teamMapHandler = (onServe, teamNumber) => { var _a, _b; return onServe ? ((_b = (_a = teamMap[teamNumber]) === null || _a === void 0 ? void 0 : _a[onServe]) !== null && _b !== void 0 ? _b : false) : false; };
export const defaultOnServeHandler = teamMapHandler;
export const baseBallOnServeHandler = teamMapHandler;
export const footballOnServeHandler = teamMapHandler;
//# sourceMappingURL=onServeHandler.js.map